import { useState } from 'react';

import Button from '../../components/Button';
import Text from '../../components/Text';
import { useDeconnexion } from '../../api/useDeconnexion';
import { t } from '../../i18n/langue';

/**
 * « Déconnecter tous mes appareils », avec sa confirmation — extrait de
 * `EtatNotifications.tsx` (#21, #28, #54, #80).
 *
 * Sous confirmation : il coupe TOUS les appareils, pas celui-ci. Le verrou et la
 * purge des brouillons sont ceux de la déconnexion simple (audit 2026-09-23, A5) :
 * un double tap ne lance qu'un appel.
 */
export default function BlocDeconnexionAppareils() {
    // Relecture M9 : un échec de `/logout-all-devices` se dit, au lieu de rien.
    const { seDeconnecterPartout, enCours: deconnexionEnCours } = useDeconnexion();

    const [confirmeDeconnexion, setConfirmeDeconnexion] = useState(false);
    const [echecDeconnexion, setEchecDeconnexion] = useState(false);

    if (!confirmeDeconnexion) {
        return (
            <Button
                libelle={t('notifications.appareils.deconnecterTous')}
                onPress={() => setConfirmeDeconnexion(true)}
                variante="discret"
                pleineLargeur
            />
        );
    }

    return (
        <div className="rounded-2xl bg-white px-5 py-4">
            <Text variante="petit" className="block leading-snug">
                {t('notifications.appareils.avertissement')}
            </Text>
            <div className="mt-3 flex flex-col gap-2">
                <Button
                    libelle={deconnexionEnCours ? t('coque.deconnexionEnCours') : t('notifications.appareils.confirmer')}
                    disabled={deconnexionEnCours}
                    onPress={() => {
                        setEchecDeconnexion(false);
                        // L'échec ne vide ni ne recharge : les appareils sont
                        // toujours connectés, rien n'a changé.
                        void seDeconnecterPartout().catch(() => setEchecDeconnexion(true));
                    }}
                    pleineLargeur
                />
                {echecDeconnexion && (
                    <div role="alert">
                        <Text variante="petit" ton="danger">
                            {t('notifications.appareils.echec')}
                        </Text>
                    </div>
                )}
                <Button
                    libelle={t('commun.annuler')}
                    onPress={() => setConfirmeDeconnexion(false)}
                    variante="discret"
                    pleineLargeur
                />
            </div>
        </div>
    );
}
